import { IconComponentProps } from '../IconTypes';

const CaretLeft = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.59 14.9975L10 12.4075C9.61002 12.0175 9.61002 11.3875 10 10.9975L12.59 8.40747C13.22 7.77747 14.3 8.22747 14.3 9.11747V14.2975C14.3 15.1875 13.22 15.6275 12.59 14.9975Z"
      fill="currentColor"
    />
  </svg>
);

export default CaretLeft;
